var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainDiv"},[_c('img',{class:_vm.$common._getTerminalMsg().isMobile ? 'imgMobile' : '',attrs:{"src":_vm.$common._getTerminalMsg().isMobile
        ? require('./img/empty_3.png')
        : require('./img/empty_1.png'),"alt":""}}),_c('div',{class:_vm.$common._getTerminalMsg().isMobile ? 'textMobile' : 'textPc'},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }